const key = 'admin-logged-in'
const EXPIRE_TIME = 3 * 24 * 60 * 60 * 1000 // 2天的毫秒数
//const EXPIRE_TIME = 10 * 1000 // 2天的毫秒数

export function loggedIn() {
  const stored = localStorage.getItem(key)
  if (!stored) return false
  
  try {
    const { value, timestamp } = JSON.parse(stored)
    const isExpired = Date.now() - timestamp > EXPIRE_TIME
    if (isExpired) {
      removeLoggedIn() // 过期则删除缓存
      return false
    }
    return value === '1'
  } catch (error) {
    // 解析失败视为无效缓存
    removeLoggedIn()
    return false
  }
}

export function setLoggedIn() {
  const data = {
    value: '1',
    timestamp: Date.now() // 存储当前时间戳
  }
  return localStorage.setItem(key, JSON.stringify(data))
}

export function removeLoggedIn() {
  return localStorage.removeItem(key)
}
